import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initEditTexts } from './lib/editTexts';
import reportWebVitals from './reportWebVitals';

// React Query
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './config/queryClient';

// Toastify-Imports
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// Veroeffentlichte Website-Texte aus AgoraHub einspielen und den Adapter fuer den Bearbeitungsmodus anmelden.
initEditTexts();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* Globaler ToastContainer für alle Toast-Nachrichten */}
      <ToastContainer position="top-right" />
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
